export default function DSA_Syllabus() {
  return <div>DSA_Syllabus Component</div>;
}
